import request from "@/utils/request";

/**
 * 获取文章
 * @param {String} type - 文章类型 article.policy：政策法规，article.guide：指南
 * @param {String} cate_id - 文章栏目
 * @param {String} page - 页码
 * @returns Promise
 */
export const getArticle = ({ type, cate_id, page }) => {
  return request("/article/list", "post", { type, cate_id, page });
};

/**
 * 获取推荐文章
 * @returns Promise
 */
export const getArticleRecommends = () => {
  return request("/article/recommends", "post");
};

/**
 * 获取文章详情
 * @param {String} id - 文章id
 * @returns Promise
 */
export const getArticleDetail = ({ id }) => {
  return request("/article/detail", "post", { id });
};
